import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router';
import { PATH } from '@old/data/core/paths';
import i18n from '../../libs/language';

export const ErrorPublicPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const message = searchParams.get('message');

  return (
    <AuthLayoutComponent>
      <Box display={'flex'} alignItems={'center'} justifyContent={'center'} width={'100%'}>
        <Stack spacing={2} alignItems={'center'}>
          <Typography variant="h5" fontWeight={300} m={0} textAlign={'center'}>
            {message ?? i18n.t('app.administrator.error_unexpected')}
          </Typography>
          <Stack direction={'row'} spacing={2}>
            <Button variant="outlined" onClick={() => navigate(-1)}>
              {i18n.t('app.return')}
            </Button>
            <Button variant="text" onClick={() => navigate(PATH.LOGIN)}>
              {i18n.t('app.public_pages.go_to_login')}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </AuthLayoutComponent>
  );
};
